export const AppPath = {
  Home: "/",
  Test: "/test",
  Course: {
    List: "/course",
    Item: "/course/:id"
  }
};
